import {createApi} from '@reduxjs/toolkit/query/react';

import {getOnlineOfferDataSearch} from '../utils/getOnlineOfferDataSearch';
import {getPdfQueryParams} from '../utils/getPdfQueryParams';
import {dmsBaseQuery} from './dmsBaseQuery';
import {BuyingOnlineOfferResponseBody} from './types/BuyingOnlineOfferResponseBody';
import {
  GetBusinessCaseOnlineOfferApiArg,
  GetPdfByOfferIdApiArg,
  GetPdfByOfferIdApiResponse,
  SendOnlineOfferEngagementApiArg,
} from './types/onlineOfferTypes';

export const buyingOnlineOfferApi = createApi({
  baseQuery: dmsBaseQuery,
  reducerPath: 'buyingOnlineOfferApi',
  endpoints: (build) => ({
    getBuyingOnlineOffer: build.query<
      BuyingOnlineOfferResponseBody,
      GetBusinessCaseOnlineOfferApiArg
    >({
      query: (queryArg) => {
        const search = getOnlineOfferDataSearch(queryArg);

        return {
          url: `/dms/v1/business-case/buying-online-offer/${queryArg.offerId}/data${search ? `?${search}` : ''}`,
          headers: {'X-Workspace': queryArg.workspace},
        };
      },
    }),
    getBuyingOnlineOfferPdf: build.query<GetPdfByOfferIdApiResponse, GetPdfByOfferIdApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/buying-online-offer/${queryArg.offerId}/pdf`,
        params: getPdfQueryParams(queryArg),
        headers: {'X-Workspace': queryArg.workspace},
      }),
    }),
    sendBuyingOnlineOfferEngagement: build.mutation<void, SendOnlineOfferEngagementApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/buying-online-offer/${queryArg.offerId}/engagement`,
        method: 'POST',
        headers: {'X-Workspace': queryArg.workspace},
        body: {
          sessionId: queryArg.sessionId,
          activeTimeMs: queryArg.activeTimeMs,
          scrollDepth: queryArg.scrollDepth,
          certificateClick: queryArg.certificateClick,
        },
      }),
    }),
  }),
});

export const {
  useGetBuyingOnlineOfferQuery,
  useLazyGetBuyingOnlineOfferPdfQuery,
  useSendBuyingOnlineOfferEngagementMutation,
} = buyingOnlineOfferApi;
